<template>
  <v-dialog v-model="visible" max-width="445" persistent>
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.deleteCostCenter`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text v-if="isValidObject(item)" class="px-4 pt-0 pb-5">
        {{ $t(`${namespace}.areYouSureDesc`) }} <strong>{{ item.name }}</strong>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer/>

        <a
          v-if="!isLoading"
          href="#"
          class="text--normal accent--text mr-4"
          color="primary"
          flat
          round
          @click.prevent="close(null)"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="primary"
          depressed
          round
          @click.native="deleteCostCenter"
        >
          {{ $t(`${namespace}.deleteCostCenter`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { isValidObject, catchError } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'SingleDeleteDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    }
  },
  data () {
    return {
      namespace: 'Views.CostCenterPage',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isValidObject(val)
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    setLoadingValue (boolean) {
      this.isLoading = boolean
    },

    async deleteCostCenter () {
      let message = null
      this.setLoadingValue(true)

      try {
        await this.$apiService.costCenter.delete(this.item.id)
        this.close(true)
        message = {
          type: 'success',
          message: this.$t(`${this.namespace}.successDelete`)
        }
      } catch (error) {
        message = {
          type: 'error',
          message: this.$t(`${this.namespace}.errorDelete`)
        }
        catchError(error)
      }

      this.showAlert(message)
      this.setLoadingValue(false)
    }
  }
}
</script>
